/**
 * Join Base `URL` and `PATH`
 * @param {*} url the base url with or without ending slashes
 * @param {*} path the url path
 * @returns string
 */
export function joinPath(url, path) {
    return url.replace(/[\/]+$/, '') + path;
}